
















































/**
 * [reflect-metadata](https://github.com/rbuckton/reflect-metadata) is used to emit metadata decorator
 * for the @Prop tag to use TypeScript type as an actual type for Vue Prop.
 */
import 'reflect-metadata'
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  /**
   * @Prop decorator is used to declare Prop.
   * Prop is accessible via HTML attribute tag.
   */
  @Prop()
  private msg!: string;
}
